import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, with later Tailwind utilities correctly overriding earlier
 * ones. `clsx` handles conditionals; `twMerge` resolves conflicts so that
 * cn('p-2', 'p-4') yields 'p-4' rather than both classes fighting.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
